import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Subject } from "rxjs";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";

@Injectable()
export class ParametrosGeraisService {
  protected paramCodMatriculaOnline: string =
    environment.paramCodMatriculaOnline;
  protected paramCodArquivoTamanhoLimite: string =
    environment.paramCodArquivoTamanhoLimite;
  protected paramCodArquivoExtensoesAceitas: string =
    environment.paramCodArquivoExtensoesAceitas;
  protected paramCodMensagemErroArquivoTamanho: string =
    environment.paramCodMensagemErroArquivoTamanho;
  protected paramCodMensagemErroArquivoExtensao: string =
    environment.paramCodMensagemErroArquivoExtensao;

  constructor(private http: Http) {}

  getParametro(parametro: string): Observable<any> {
    return this.http
      .get(parametro)
      .map((res) => res.json())
      .catch((err: any) => {
        return Observable.throw(err.json());
      });
  }

  async getArquivoTamanhoLimite() {
    const url = environment.urlDpParametros + this.paramCodArquivoTamanhoLimite;

    var subject = new Subject<string>();

    this.getParametro(url).subscribe(
      ({
        ParNum: {
          0: { ParNumDes: arquivoTamanhoLimite },
        },
      }) => subject.next(arquivoTamanhoLimite),
      (err) => subject.error(err)
    );

    return subject.asObservable();
  }

  async getArquivoExtensoesAceitas() {
    const url =
      environment.urlDpParametros + this.paramCodArquivoExtensoesAceitas;

    var subject = new Subject<string>();

    this.getParametro(url).subscribe(
      ({
        ParChar: {
          0: { ParCharDes: extensoesAceitas },
        },
      }) => {
        let extensoes = extensoesAceitas.split(",").map((e) => e.toLowerCase());
        extensoes = new Set(extensoes);
        extensoes = Array.from(extensoes) as string[];
        extensoes = extensoes.sort();

        subject.next(extensoes);
      },
      (err) => subject.error(err)
    );

    return subject.asObservable();
  }

  async getMensagemErroArquivoTamanho() {
    const url =
      environment.urlDpParametros + this.paramCodMensagemErroArquivoTamanho;

    var subject = new Subject<string>();

    this.getParametro(url).subscribe(
      ({
        ParClob: {
          0: { ParClobDes: mensagemErro },
        },
      }) => subject.next(mensagemErro),
      (err) => subject.error(err)
    );

    return subject.asObservable();
  }

  async getMensagemErroArquivoExtensao() {
    const url =
      environment.urlDpParametros + this.paramCodMensagemErroArquivoExtensao;

    var subject = new Subject<string>();

    this.getParametro(url).subscribe(
      ({
        ParClob: {
          0: { ParClobDes: mensagemErro },
        },
      }) => subject.next(mensagemErro),
      (err) => subject.error(err)
    );

    return subject.asObservable();
  }

  async getMatriculaOnlineUrl() {
    const url = environment.urlDpParametros + this.paramCodMatriculaOnline;

    var subject = new Subject<string>();

    this.getParametro(url).subscribe(
      ({
        ParChar: {
          0: { ParCharDes: matriculaOnlineUrl },
        },
      }) => subject.next(matriculaOnlineUrl),
      (err) => subject.error(err)
    );

    return subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/parametros-gerais/parametros-gerais.service.ts